import Link from "components/shared/Link";
import Icon from "components/shared/Icon";
import { Fragment } from "react";
import Profile from "components/header/profile/Profile";
import AccessibleText from "components/shared/AccessibleText";
import { getCdn } from "utils";
import appConfig from "config.json";

const { targetOneId } = appConfig;
const mainClass = "syndicated-section-title";
const mainLinkClass = `${mainClass}__link`;

const SectionTitle = (props) => {
	const {
		collapse,
		link,
		name,
		icon = "",
		title = "",
		isMobileView = false,
		accessibiltyText,
		brand,
		isMenuActive,
	} = props;
	const isOpened = isMobileView && collapse;
	const inlineStyles = {};
	if (name === "mdx") {
		inlineStyles.backgroundImage = `url(${getCdn()}/logos/header/mdx.svg)`;
	}
	let classes = `${mainClass} ${mainClass}--${name} ${mainClass}--${brand}${
		!link?.href ? ` ${mainClass}--no-link` : ""
	}`;
	if (isOpened) classes += ` ${mainClass}--open`;

	const linkContent = (
		<Fragment>
			<Icon
				icon={"norgie-closed"}
				rotate={collapse}
				className={`${mainLinkClass}__icon ${mainLinkClass}__icon--norgie-closed`}
			/>
			<Icon
				icon={icon}
				className={`${mainLinkClass}__icon ${mainLinkClass}__icon--${name}`}
			/>
			<div
				className={`${mainLinkClass}__category--${name}`}
				dangerouslySetInnerHTML={{ __html: title }}
				style={inlineStyles}
			/>
			{accessibiltyText && <AccessibleText>{accessibiltyText}</AccessibleText>}
		</Fragment>
	);

	return (
		<div className={classes}>
			{!isMobileView && link?.target === targetOneId ? (
				<Profile
					oneId
					notLoggedIn
					target={link.target}
					renderComponent={(handleClick) => (
						<Link
							{...link}
							handleClick={handleClick}
							className={`${mainLinkClass}`}
							role={isMenuActive ? "link" : "menuitem"}
							collapse={isMobileView ? collapse : null}
						>
							{linkContent}
						</Link>
					)}
				/>
			) : (
				<Link
					{...link}
					className={`${mainLinkClass} ${mainLinkClass}--${brand}${
						isOpened ? ` ${mainLinkClass}--open` : ""
					}${!link?.href ? ` ${mainLinkClass}--no-link` : ""}`}
					role={isMenuActive ? "link" : "menuitem"}
					collapse={isMobileView ? collapse : null}
					renderNotLinkTitle={
						!link?.href ||
						(isMobileView &&
							appConfig.brands[brand]?.removeLinksInMobileViewSections)
					}
				>
					{linkContent}
				</Link>
			)}
		</div>
	);
};

export default SectionTitle;
